import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostNotice = (titleRef, contentRef, imgListState) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("POST", `/admin/notice`, {
            "title": titleRef?.current?.value,
            "content": contentRef?.current?.value,
            "img_list": imgListState
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate("/notice")
                break
            case 400:
                if (fetchResult?.data?.error_code === "title") setAlert("제목을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "content") setAlert("본문을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "img_list") setAlert("이미지 목록을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePostNotice